import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import CategoryTreePage from '@features/admin/category-tree/CategoryTreePage.tsx';
import { useCategoryTreeStore } from '@features/admin/category-tree/categoryTreeStore';

const categoryTreeSearchSchema = z.object({
  query: z.string().optional(),
});

export const Route = createFileRoute('/admin/category-tree')({
  validateSearch: search => categoryTreeSearchSchema.parse(search),
  component: RouteComponent,
  beforeLoad: async ({ search }) => {
    await useCategoryTreeStore.getState().fetchCategoryTree(search.query);
  },
});

function RouteComponent() {
  return <CategoryTreePage />;
}
